import { over, lensProp } from 'ramda';
import { toast } from 'react-toastify';
import { formatToOnlyNumbers } from '../../../helpers/formatters';

import {
  fetchEmployee,
  createNewEmployee,
  updateEmployee,
  requestUpdateEmployeePassword,
  requestUpdateMainUser,
  requestSetMainUserSL,
  fetchRestrictions
} from './services';

import {
  setEmployeeId,
  setEmployee,
  setEmptyEmployee,
  setRestrictions,
  handleLoading,
  handleMainUserLoading,
  handleRestrictionsLoading
} from './actions';

export const loadEmployee = (userId, employeeId) => dispatch => {
  if(!userId) {
    return dispatch(setEmptyEmployee());
  }

  dispatch(handleLoading(true));

  return fetchEmployee(userId, employeeId)
    .then(({ data }) => {
      dispatch(setEmployee(data));
      dispatch(loadRestrictions(userId));
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const loadRestrictions = userId => dispatch => {
  dispatch(handleRestrictionsLoading(true));

  return fetchRestrictions(userId)
    .then(response => dispatch(setRestrictions(response.data)))
    .finally(() => dispatch(handleRestrictionsLoading(false)));
}

export const upsertEmployee = (
  userRegistration,
  userId,
  params,
  isInitialRegistration = false
) => dispatch => {
  const formatParams = over(lensProp('phone'), formatToOnlyNumbers, params);

  formatParams.appRestrictions = formatParams.appRestrictions?.length > 0
    ? formatParams.appRestrictions
    : '[]';

  formatParams.userRestrictions = formatParams.userRestrictions?.length > 0
    ? formatParams.userRestrictions
    : '[]';

  dispatch(handleLoading(true));

  if(!userId) {
    return createNewEmployee(userRegistration, formatParams)
      .then(({ data }) => {
        toast.success('Usuário criado com sucesso.');

        if(!isInitialRegistration) {
          dispatch(setEmployeeId(data.userId));
        }
      })
      .finally(() => dispatch(handleLoading(false)));
  }

  return updateEmployee(userRegistration, userId, formatParams)
    .then(({ data }) => {
      toast.success('Usuário atualizado com sucesso.');

      if(!isInitialRegistration) {
        dispatch(setEmployeeId(data.userId));
      }
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const updateEmployeePassword = (userId, employeeId, params) => dispatch => {
  dispatch(handleLoading(true));

  return requestUpdateEmployeePassword(userId, employeeId, params)
    .then(() => {
      toast.success('Senha do usuário atualizada com sucesso!');
      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleLoading(false)));
}

export const updateMainUser = (userId, employeeId, params) => dispatch => {
  dispatch(handleMainUserLoading(true));

  return requestUpdateMainUser(userId, employeeId, params)
    .then(({ data }) => {
      toast.success(data?.message);
      dispatch(loadEmployee(userId, employeeId));

      return Promise.resolve();
    })
    .catch(() => {
      return Promise.reject();
    })
    .finally(() => dispatch(handleMainUserLoading(false)));
}

export const setMainUserSL = (userId, mainUserId) => dispatch => {
  dispatch(handleMainUserLoading(true));

  return requestSetMainUserSL(userId, mainUserId)
    .then(() => dispatch(loadEmployee(userId, mainUserId)))
    .finally(() => dispatch(handleMainUserLoading(false)));
}